const n = (e) => {
  switch (e) {
    case "number":
      return;
    case "selection":
      return;
    case "multiselection":
      return [];
    default:
      return "";
  }
}, i = (e) => !e || e.length === 0 ? {} : e.reduce((t, r) => "type" in r ? r.type === "form_input" ? {
  ...t,
  [r.name]: n(r.inputType)
} : {
  ...t,
  ...i(r.children)
} : t, {});
export {
  i as generateFormInitialValue
};
